// extracted by mini-css-extract-plugin
module.exports = {"related":"related_related__p3W29"};